exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-table[data-v-0ad4efd0] {\n  max-width: 100%;\n  min-width: 1200px;\n}\n.tag-info[data-v-0ad4efd0] {\n  font-size:14px;\n  height:32px;\n  line-height:32px;\n  width:100%;\n  padding: 0px 11px;\n  color: #bbb;\n  background-color: #ffffff;\n}\n", ""]);

// exports
